/*global flexibility localized Flickity objectFitImages */

// helper functions to toggle a class name on an element
function removeClass(el, classname) {
	el.className = el.className.replace(" " + classname, "");
	el.className = el.className.replace(classname, "");
}

function addClass(el, classname) {
	el.className += " " + classname;
}

function hasClass(el, classname) {
	return ((" " + el.className + " ").replace(/[\t\r\n]/g, " ").indexOf(" " + classname + " ") >= 0);

}

function toggleClass(el, classname) {
	if (hasClass(el, classname)) {
		removeClass(el, classname);
	} else {
		addClass(el, classname);
	}
}

function is_ieedge() {
	var rv = false; // Return value assumes failure.

	if (/MSIE 10/i.test(navigator.userAgent)) {
		// This is internet explorer 10
		rv = 10;
	}
	if (/MSIE 9/i.test(navigator.userAgent)) {
		rv = 9;
	}
	if (/rv:11.0/i.test(navigator.userAgent)) {
		rv = 11;
	}
	if (/Edge\/\d./i.test(navigator.userAgent)) {
		rv = 'edge';
	}
	return rv;
}

function injectscript(url, callback){
    var script = document.createElement("script")
    script.type = "text/javascript";
    if (script.readyState) { //IE
        script.onreadystatechange = function () {
            if (script.readyState === "loaded" || script.readyState === "complete") {
                script.onreadystatechange = null;
                callback();
            }
        };
    } else { //Others
        script.onload = callback;
    }
    script.src = url;

    var firstscript = document.getElementsByTagName('script')[0];
    firstscript.parentNode.insertBefore(script, firstscript);
}

(function (d) {
	"use strict";

	// inject the EDGE object-fit polyfix & Flexbox polyfix
	if (is_ieedge() ) {
        //object fit
        injectscript(localized.themeURL + '/dist/scripts/ofi.min.js', function(){
            objectFitImages(false, {
                watchMQ: true,
                skipTest: true
            });
        });
    }
	if (is_ieedge() && is_ieedge() <= 10 ) {
        //flexbox
        injectscript(localized.themeURL + '/dist/scripts/flexibility.js', function(){
            var sectionbody = document.querySelectorAll('.section-body');
            for (var index = 0; index < sectionbody.length; index++) {
                flexibility(sectionbody[index]);      
            }
            flexibility(document.querySelector('.story-header, .category-body, #archiveCont'));
        });

    }

}(document));

/*
 * Scripts for Sidebar
//  */
// (function (d){
// 	function sidebarActivator(e) {
//         e.stopPropagation();
//         fetcharchives();
// 		var thePanel = d.getElementById('sidebar');
//         if (!hasClass(thePanel, 'activated')) {
//             addClass(d.querySelector('html'), 'noOverflow');
//             addClass(thePanel, 'transition');
//             addClass(thePanel, 'activated');
//             setTimeout(function(){
//                 removeClass(thePanel, 'transition')
//             }, 400);            
//         }
// 	}

// 	function sidebarDeactivator() {
// 		var thePanel = d.getElementById('sidebar');
//         if (hasClass(thePanel, 'activated')) {
//             addClass(thePanel, 'transition');
//             removeClass(thePanel, 'activated');
//             setTimeout(function(){
//                 removeClass(thePanel, 'transition');
//                 removeClass(d.querySelector('html'), 'noOverflow');
//             }, 400);
//         }
// 	}   

//     var thePanel = d.getElementById('sidebar');
//     var theBody = d.getElementsByTagName("BODY")[0];

// 	// header event Handlers
// 	// d.getElementById('sidebar-activate').addEventListener('click', sidebarActivator);
//     // theBody.addEventListener('click', sidebarDeactivator);
//     // thePanel.addEventListener('click', function(e){ e.stopPropagation() });
// 	// d.getElementById('sidebar-deactivate').addEventListener('click', sidebarDeactivator);   

//     // Search 
//     var searchRunning = false;
//     function searchPosts(e){
        
//         e.preventDefault();
//         // don't allow search if it hasn't finished yet
//         if (searchRunning) {
//             return;
//         }
//         searchRunning = true;
        
//         var searchVal = d.getElementById('search-input').value;
//         var searchDiv = d.getElementById('searchResults');
//         var searchHead = d.getElementById('searchHead');
        
//         // stop if search is nothing
//         if (searchVal == ""){
//             searchDiv.innerHTML = "no results found";
//             searchRunning = false;
//             return;
//         }

//         d.getElementById('searchResults').innerHTML = '';

//         // hide everything that isn't search.
//         if (!(hasClass(d.getElementById('menu'), 'noDisplay'))){
//             addClass( d.getElementById('menu'), 'noDisplay');
//         }
//         if (!(hasClass(d.getElementById('archFormCont'), 'noDisplay'))){
//             addClass( d.getElementById('archFormCont'), 'noDisplay');
//         }
//         removeClass(searchDiv, 'noDisplay');
//         removeClass(searchHead, 'noDisplay');
//         var AJAXUrl = localized.ajaxURL.replace("wp-admin\/admin-ajax.php", "") + "wp-json/wp/v2/posts?per_page=100&search=" + encodeURIComponent(searchVal);

//         var searchXHR = new XMLHttpRequest();
//         searchXHR.open("GET", AJAXUrl, true);
//         searchXHR.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
//         searchXHR.send();

//         function transferComplete(){
//             var theArticles = JSON.parse(this.responseText);
//             // If there are no results, display a 'not found' msg, 
//             // and end the function
//             if (!theArticles[0]){
//                 d.getElementById('searchResults').innerHTML = "<p class='search-none'>No results found</p>";
//                 searchRunning = false;
//                 return;
//             }
            
//             // go through each object in the JSON and create html elements
//             var articlesHTML = '';
//             for (var i = 0; i < theArticles.length; i++) {
//                 var curArticle = theArticles[i];
//                 articlesHTML += ""+
//                     "<article>" +
//                         "<a href='" + decodeURI(curArticle.link) + "'>";
//                         if (curArticle.thumbnail) {
//                             articlesHTML += "" +
//                             "<div class='search-image-wrapper'>" +
//                                 "<div class='search-image'>" +
//                                     curArticle.thumbnail + 
//                                 "</div>" +
//                             "</div>";
//                         }
//                         articlesHTML += "" +
//                             "<header class='search-header'>" +
//                                 "<h4 class='search-title'>" + curArticle.title.rendered + "</h4>" +
//                                 "<div class='search-subHead'>" + 
//                                     curArticle.excerpt.rendered + 
//                                 "</div>" +
//                                 "<p class='search-cat'>" + curArticle.issue + " | " + curArticle.catString + "</p>" + 
//                             "</header>" +
//                         "</a>" +
//                     "</article>";
//             }
//             d.getElementById('searchResults').innerHTML = articlesHTML;
//             searchRunning = false;
//         }

//         function transferFailed(){
//             console.log(this.responseText);
//             searchRunning = false;
//         }

//         searchXHR.addEventListener('load', transferComplete);
//         searchXHR.addEventListener('error', transferFailed);
//     }

//     // Search Close (return sidebar to show all things)
//     function searchCloser() {
//         // hide everything that isn't search.
//         addClass(d.getElementById('searchHead'), 'noDisplay');
//         addClass(d.getElementById('searchResults'), 'noDisplay');
//         removeClass(d.getElementById('menu'), 'noDisplay');
//         removeClass(d.getElementById('archFormCont'), 'noDisplay');
//     }

//     // Archive
//     var archiveRunning = false;
//     var haveachives = false;
//     var AJAXUrl = localized.ajaxURL.replace("wp-admin\/admin-ajax.php", "") + "wp-json/wp/v2/issue?per_page=100";

//     //on load fetch the archives

//     function fetcharchives(){
//         if(haveachives || archiveRunning) return;
//         archiveRunning = true;

//         var archiveXHR = new XMLHttpRequest();

//         archiveXHR.open("GET", AJAXUrl, true);
//         archiveXHR.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
//         archiveXHR.send();

//         function transferComplete(){
//             var theIssues = JSON.parse(this.responseText);
//             // go through each object in the JSON and create html elements
//             var issuesHTML = '';
//             for (var i = 0; i < theIssues.length; i++) {
//                 var curIssue = theIssues[i];
//                 issuesHTML += ""+
//                     "<article>" +
//                         "<a href='" + decodeURI(curIssue.link) + "' target='_blank'>";
//                         if (curIssue.thumbnail) {
//                             issuesHTML += "" +
//                             "<div class='preview-image'>" +
//                                 curIssue.thumbnail +
//                             "</div>";
//                         }
//                         issuesHTML += "" +
//                             "<header class='preview-header'>" +
//                                 "<h3 class='preview-title'>" + curIssue.title.rendered + "</h3>" +
//                             "</header>" +
//                         "</a>" +
//                     "</article>";
//             }

//             d.getElementById('archiveCont').innerHTML = issuesHTML;
//             haveachives = true;
//             archiveRunning = false;
            
//         }

//         function transferFailed(){
//             console.log(this.responseText);
//             archiveRunning = false;
//         }

//         archiveXHR.addEventListener('load', transferComplete);
//         archiveXHR.addEventListener('error', transferFailed);
//     };

//     function archivePosts(e){
//         e.preventDefault();
//         removeClass(d.getElementById('archiveCont'), 'hidden');
//         //d.querySelector('.archives-link').removeEventListener('click', archivePosts);
//         return false;
//     }
//     d.querySelector('.archives-link').addEventListener('click', archivePosts);

//     d.getElementById('search-submit').addEventListener('click', searchPosts);
//     d.getElementById('search-close').addEventListener('click', searchCloser);
// }(document));

/*
 * Scripts for Footer Forms
 */
(function (d){
    // the AJAX url
    var AJAXUrl = localized.ajaxURL;
    
    // Newsletter AJAX
    /*
    function newsletterReq(e) {
        e.preventDefault();
        var emailEl = d.getElementById('email');
        if (hasClass(emailEl, 'emailError')){
            removeClass(emailEl, 'emailError')
        }
        if (hasClass(emailEl, 'invalidError')){
            removeClass(emailEl, 'invalidError')
        }

        // grab the email from the input
        var emailVal = emailEl.value.trim();

        // test for regex


        // If there's a value, go for it 
        if (emailVal !== '') {
            // prepare data the WP way
            var params = "action=newsletter_ajax" +
                         "&email=" + emailVal;
            // Send that email.
            // set up the xhr for the newsletter
            var newsletterXHR = new XMLHttpRequest();
            newsletterXHR.open("POST", AJAXUrl, true);
            newsletterXHR.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
            newsletterXHR.send(params);
            // Response Functions
            function transferComplete(){
                // Thank you msg
                var thanks = "<h4>Thank you!</h4>" +
                            "<p>We'll add your email to our mailing list.</p>";
                d.getElementById("nlFormCont").innerHTML = thanks;
            }
            function transferFailed(){
                // error msg
                var uhoh = "<h4>Something happened...</h4>" +
                            "<p>The site encountered an error while attempting to add you to our mailing list&mdash;we couldn't process the request. Please try again later.</p>";
                d.getElementById("nlFormCont").innerHTML = uhoh;
            }
            // Response Handlers
            newsletterXHR.addEventListener("error", transferFailed);
            newsletterXHR.addEventListener("load", transferComplete);
        } else {
            addClass(emailEl, 'emailError');
        }
    }
    */
    // click the Activator
    /*
    function revealForm(element) {
        var activator = element.lastElementChild;
        var theForm = element.parentElement.querySelector('.formCont');

        if (hasClass(activator, 'plus')) {
            activator.innerHTML = '<p>&ndash;</p>';
            removeClass(activator, 'plus');
            addClass(activator, 'minus');
            addClass(theForm, 'shown');
        } else if (hasClass(activator, 'minus')) {
            activator.innerHTML = '<p>+</p>';
            removeClass(activator, 'minus');
            addClass(activator, 'plus');
            removeClass(theForm, 'shown');
        }
    } */
    /*
    // Subscription AJAX
    function subscribeReq(e) {
        e.preventDefault();
        // grab all form elems
        var fname = d.getElementById('fname');
        var lname = d.getElementById('lname');
        var address = d.getElementById('address');
        var city = d.getElementById('city');
        var state = d.getElementById('state');
        var zip = d.getElementById('zip');
        // save all elements into array
        var formElems = [fname, lname, address, city, state, zip];
        // check that each element has value, display error if so
        var formErrors = false
        for (var i = formElems.length; i--;) {
            if (hasClass(formElems[i], 'inputError')) {
                removeClass(formElems[i], 'inputError')
            }
            formElems[i].value = formElems[i].value.trim()
            if (formElems[i].value.trim() === '') {
                if (!formErrors){
                    formErrors = true;
                }
                addClass(formElems[i], 'inputError');
            }
        }
        // if found error, stop function
        if (formErrors) {
            return;
        }
        // Otherwise, parse the form elements into params for subscribe ajax 
        var params = "action=subscribe_ajax" +
                     "&fname=" + fname.value +
                     "&lname=" + lname.value +
                     "&address=" + address.value +
                     "&city=" + city.value +
                     "&state=" + state.value +
                     "&zip=" + zip.value;
        // 2. Set up XHR and send 
        // Send that email.
        // set up the xhr for the newsletter
        var subscribeXHR = new XMLHttpRequest();
        subscribeXHR.open("POST", AJAXUrl, true);
        subscribeXHR.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        subscribeXHR.send(params);
        // Response Functions
        function transferComplete(){
            // Thank you msg
            var thanks = "<h4>Thank you!</h4>" +
                         "<p>We'll add your address to our subscriber list.</p>";
            d.getElementById("subFormCont").innerHTML = thanks;
        }
        function transferFailed(){
            // error msg
            var uhoh = "<h4>Something happened...</h4>" +
                         "<p>We were unable to process your subscription. Please try again later.</p>";
            d.getElementById("subFormCont").innerHTML = uhoh;
        }
        // Response Handlers
        subscribeXHR.addEventListener("error", transferFailed);
        subscribeXHR.addEventListener("load", transferComplete);

    }
    */
    // Button Events
    /*
    d.getElementById('subHeader').addEventListener('click', function(){revealForm(this)});
    d.getElementById('nlHeader').addEventListener('click', function(){revealForm(this)});
    */
    //d.getElementById('submitNL').addEventListener('click', newsletterReq);
    //d.getElementById('submitSub').addEventListener('click', subscribeReq);
}(document));